import type { FieldSchema } from '../../../../../schema-types'

/** Add-to-cart button slot the Pathok product card reads (label, background, text colour). */
export const addToCartButtonFields: FieldSchema[] = [{
  key: 'buttons.addToCart',
  label: 'Add to cart button',
  type: 'object',
  preview: { type: 'button', variant: 'primary', defaultLabel: 'Add to cart' },
  fields: [
    { key: 'label', label: 'Button text', type: 'string' },
    { key: 'bg', label: 'Background colour', type: 'color' },
    { key: 'text', label: 'Text colour', type: 'color' },
  ],
}]

/** Plain heading pair (title, subtitle) the shared section types store. */
export const titleFields = (title: string): FieldSchema[] => [
  { key: 'title', label: 'Title', type: 'string', default: title },
  { key: 'subtitle', label: 'Subtitle', type: 'string' },
]

/** Pages a product list section can be placed on. */
export const PRODUCT_PAGES = ['home', 'shop', 'category', 'categories']
